<app-topnav></app-topnav>

<!-- HEADER -->
<app-header-secondary-h *ngIf="currentLang ==='fr'" [pageTitle]="'Fenêtres sur la Gestion des Inscriptions (FGI)'" 
    [pageDescription]="['Notre logiciel de Fenêtres sur la', 'Gestion des Inscriptions passe le test!']"
    [imageURL]="'assets/img/logiciels/FGI_top.png'" ></app-header-secondary-h>
<app-header-secondary-h *ngIf="currentLang ==='en'" [pageTitle]="'Fenêtres sur la Gestion des Inscriptions (FGI)'" 
    [pageDescription]="['Our registration management', 'software passes the test!']"
    [imageURL]="'assets/img/logiciels/FGI_top.png'" ></app-header-secondary-h>
<!-- end HEADER -->

<!-- SECTION characteristics -->
<section id="section-characteristics">
        <div id="section-characteristics-inner">
            <div class="container">
                <div class="row">
                    <div class="col col-12" *ngIf="currentLang ==='fr'">
                        <h2 class="section-title">
                            <strong>Caractéristiques et avantages</strong>
                        </h2>
                        <p>Avec le logiciel FGI, c’est maintenant plus facile de gérer les demandes d’admission de vos futurs élèves. Par l’entremise d’un formulaire simple et concis, disponible en ligne, le parent fait une demande d’inscription pour son enfant. Vous voilà délesté d’une tâche administrative, car il ne vous reste plus qu’à valider les données et poursuivre votre processus d’inscription par la suite. FGI vous accompagne donc de l’ouverture du dossier d’un élève à l’obtention de son diplôme.</p>
                    </div>
                    <div class="col col-12" *ngIf="currentLang ==='en'">
                            <h2 class="section-title">
                                <strong>Benefits and key features</strong>
                            </h2>
                            <p>Thanks to FGI, it is now easier than ever to manage the requests for admission of your future students. By means of a short and simple form, available online, the parents proceed with the request for admission. Your administrative workload is then reduced, since you just need to validate the data and continue with the registration process. Our window on registration supports you with the creation of the student’s record, from the beginning to the graduation.</p>
                        </div>
                    </div>
    
                <div class="row">
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_01.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">Économie de temps considérable grâce à l’entrée des informations par les parents directement sur le web (réduction du risque d’erreur).</p>
                                    <p *ngIf="currentLang ==='en'">Significant economy of time, thanks to the data entry made by the parents directly on Internet (lower risk of errors).</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_02.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">Classement des groupes à l’aide de statistiques.</p>
                                    <p *ngIf="currentLang ==='en'">Classification of the groups by means of statistics.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_03.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">Personnalisation des verdicts d’admission (ex. : admis, en attente, etc.).</p>
                                    <p *ngIf="currentLang ==='en'">Personalization of the admission status (admitted, on waiting list, etc.).</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_04.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">Calcul du score global de l’élève (pondérations personnalisables).</p>
                                    <p *ngIf="currentLang ==='en'">Calculation of total score, according to personalizsable weighting.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
        </div>
    </section>
    <!-- end SECTION characteristics -->
    
    <!-- SECTION - taquets -->
    <app-taquets *ngIf="currentLang ==='fr'" #ref [title]="taquets.title" [description]="taquets.description" [items]="taquets.items">
        <div class="taquets-slides">
            <div class="taquets-slide" [class.active]="ref.selected === 0">
    
                <h2 class="section-title"><strong>Communications</strong></h2>
                <p>Entrer en contact avec les candidats via le Pluriportail vous permet de gagner du temps et réaliser de grandes économies de papier! Réduire notre empreinte écologique est un geste qui compte et qui commence par l’envoi de courriels de masse. Ainsi, les parents peuvent accéder au Pluriportail en tout temps pour communiquer avec l’école et suivre en ligne la demande d’admission de leur enfant, en plus de télécharger tous les documents nécessaires (ex. : bulletins, acte de naissance, etc.).</p>

            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 1">
    
                <h2 class="section-title"><strong>Examens d'admission</strong></h2>
                <p>Gérer les examens d’admission est rapide, car après avoir entré les résultats des candidats dans le logiciel FGI, le système effectue le travail à votre place en ce qui a trait aux évaluations, statistiques, relevés de notes, etc.</p>
    
            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 2">
    
                <h2 class="section-title"><strong>Rapports</strong></h2>
                <p>Vous êtes le maître d’œuvre de la démarche d’admission de votre institution. Ainsi, il vous sera facile de créer des listes et de préparer divers rapports comme des listes de groupes de candidats, des lettres d’acceptation, etc.</p>
    
            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 3">
    
                <h2 class="section-title"><strong>Transfert</strong></h2>
                <p>C’est un logiciel qui procède par enregistrement et téléversement de données, en transférant les informations du candidat vers le logiciel de pédagogie, lorsque sa candidature a été retenue.</p>
    
            </div>

        </div>
    </app-taquets>
    <app-taquets *ngIf="currentLang ==='en'" #ref [title]="taquets.titleEN" [description]="taquets.descriptionEN" [items]="taquets.itemsEN">
        <div class="taquets-slides">
            <div class="taquets-slide" [class.active]="ref.selected === 0">
    
                <h2 class="section-title"><strong>Communications</strong></h2>
                <p>The ability to come into contact with the applicants via the Pluriportail allows you to save time and to save on paper consumption. The reduction of our economic footprint is to be taken seriously and one of the first steps is to contact people by massive emails. As for the parents, they can have access to the Pluriportail at all times to communicate with the school and follow online their child’s admission request. They are also allowed to download all relevant documents (school reports, birth certificate, etc.)</p>

            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 1">
    
                <h2 class="section-title"><strong>Admission examination</strong></h2>
                <p>The management of school admission examination is quick: after having entered the candidate results into the FGI software, the system does the job for you as for assessments, statistics, grade transcripts, etc.</p>
    
            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 2">
    
                <h2 class="section-title"><strong>Reports</strong></h2>
                <p>You are the manager responsible for the admission procedures in your institution. It is now easy for you to set up lists and draft various reports concerning groups of candidates, acceptance letters, etc.</p>
    
            </div>
            <div class="taquets-slide" [class.active]="ref.selected === 3">
    
                <h2 class="section-title"><strong>Transfer</strong></h2>
                <p>This software functions proceeds with data registration and uploading of data, by transferring the candidate’s information toward the pedagogical software when the candidate’s application has been accepted.</p>
    
            </div>

        </div>
    </app-taquets>
    <!-- end SECTION - taquets -->
    
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    
    
<app-footer></app-footer>
    